import React from 'react'
import { navigateTo } from 'gatsby-link'

import SymbolAtlas from '../container/SymbolAtlas'
import SymbolLegend from '../components/SymbolLegend'
import Popup from '../components/Popup.js'
import Quelle from '../components/Quelle.js'

import symbols from '../data/symbols.js'
import bezirke from '../data/bezirke'

class Betreuungseinrichtungen extends React.Component {
  clickOnGemeinde = iso => {
    const bezirk = bezirke.find(b => b.filter(iso))
    if (bezirk.zoomToIso === this.props.pathContext.zoomToIso) {
      this.openPopup(iso)
    } else {
      this.setZoomToIso(bezirk.zoomToIso)
    }
  }

  setZoomToIso = (iso = 0) => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.zoomToIso === iso &&
        e.node.fields.showPopup === false
    ).node.path
    navigateTo(path)
  }

  closePopup = () => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.zoomToIso === this.props.pathContext.zoomToIso &&
        e.node.fields.showPopup === false
    ).node.path
    navigateTo(path)
  }

  openPopup = iso => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.popup === Number(iso) &&
        e.node.fields.showPopup === true
    ).node.path
    navigateTo(path)
  }

  render() {
    return (
      <div className="content-box">
        <h2>Betreuungseinrichtungen</h2>
        {this.props.pathContext.showPopup ? (
          <Popup
            closePopup={this.closePopup}
            data={this.props.data}
            openPopup={this.openPopup}
            menu="1"
          />
        ) : null}
        <div style={{ breakAfter: false }}>
          <SymbolLegend
            symbols={symbols}
            label={`${this.props.pathContext.name
              ? `Bezirk ${this.props.pathContext.name}`
              : 'Burgenland'}`}
          />
          <div className="content-map-div">
            <SymbolAtlas
              data={this.props.data.alleGemeinden.edges}
              symbols={symbols}
              zoomToIso={this.props.pathContext.zoomToIso}
              setZoomToIso={this.setZoomToIso}
              clickOnGemeinde={this.clickOnGemeinde}
            />
          </div>
        </div>
        <Quelle>
          Quelle: Amt der Burgenländischen Landesregierung,
          Kindertagesheimstatistik 2025/2026; Gemeindekooperationen:
          telefonische Erhebung bei den Gemeindeämtern (Oktober 2017)
        </Quelle>
      </div>
    )
  }
}

export default Betreuungseinrichtungen

export const query = graphql`
  query PopupQuery($popup: Int!) {
    alleGemeinden: allGemeinden202526Json {
      edges {
        node {
          iso
          name
          Anz_Krippe
          Anz_KiGa
          Anz_alterserw_KiGa
          VS_Ki_NMB_vorh
          VIF_Kategorie
        }
      }
    }
    allSite: allSitePage(
      filter: { path: { regex: "/Betreuungseinrichtungen/" } }
    ) {
      edges {
        node {
          path
          fields {
            title
            zoomToIso
            popup
            showPopup
          }
        }
      }
    }
    gemeinde: gemeinden202526Json(iso: { eq: $popup }) {
      iso
      name
      VIF_Kategorie
      Anz_Krippe
      Anz_KiGa
      Anz_alterserw_KiGa
      Anz_Hort
      schulischeNMB_VS_Ki
      oeffTag_0_3J
      oeffTag_3_6J
      oeffWoche_0_3J
      oeffWoche_3_6J
      geschlJahr_0_3J
      geschlJahr_3_6J
      Mittagessen_0_3
      Mittagessen_3_6
      VS_Ki_NMB
    }
    betriebe: allBetriebe202526Json(filter: { GEMNR: { eq: $popup } }) {
      edges {
        node {
          Kennzahl
          Bezeichnung
          Adresse
          PLZ
          Ort
          Movon1
          Mobis1
          Divon1
          Dibis1
          Mivon1
          Mibis1
          Dovon1
          Dobis1
          Frvon1
          Frbis1
          Movon2
          Mobis2
          Divon2
          Dibis2
          Mivon2
          Mibis2
          Dovon2
          Dobis2
          Frvon2
          Frbis2
          Sommer
          Weihnacht
          Semester
          Ostern
          sonstzu
          Essen
        }
      }
    }
    zusatzGemeinden: allGemeindenZusatzinfosJson(
      filter: { Code_2015: { eq: $popup } }
    ) {
      edges {
        node {
          Website_Gemeinde
          Telefon_Gemeinde
          Zusatzinfo
        }
      }
    }
    zusatzBetriebe: allBetriebeZusatzinfosJson(
      filter: { GEMNR: { eq: $popup } }
    ) {
      edges {
        node {
          Kennzahl
          Telefon_Einrichtung
        }
      }
    }
    kooperationen: allKooperationen2025Json {
      edges {
        node {
          iso
          koop_u3J_GEM
          koop_3_6J_GEM
          koop_NMB_GEM
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/facilities.js